import { Injectable } from '@angular/core';

function _window(): Window {
  return window;
}

@Injectable()
export class Globals {
  public get nativeWindow(): Window {
    return _window();
  }

  public get localStorage(): Storage {
    return this.nativeWindow.localStorage;
  }
}
